// extracted by mini-css-extract-plugin
export var gif = "_ir-0";